import {useCallback, useContext, useEffect} from 'react';

import {ClientContext} from 'context';
import {ClientSessionParams} from 'types';
import {logger} from 'utils';
import {parseJsonOrObject} from 'utils/transform';

import {mockStartSessionParams} from '../constants';
import {SessionInterfaceEvent} from '../types';

export const ClientConferenceSDKInterface: React.FC = () => {
    const {
        isDevelopmentMode, waitingStartSessionFromChildren,
        handleUploadSelfieVerificationResult, startSessionWithParams, endLocalSession
    } = useContext(ClientContext);

    const handleOpenSession = useCallback((clientSessionParamsString: string | ClientSessionParams) => {
        startSessionWithParams(parseJsonOrObject<ClientSessionParams>(clientSessionParamsString).value);
    }, [startSessionWithParams]);

    const onEvent = useCallback((payload: {name: SessionInterfaceEvent, data: any}) => {
        switch (payload?.name) {
            case SessionInterfaceEvent.OpenSession:
                handleOpenSession(payload?.data);
                break;
            case SessionInterfaceEvent.SelfieVerificationResult:
                handleUploadSelfieVerificationResult(payload?.data);
                break;
            case SessionInterfaceEvent.EndSession:
                endLocalSession();
                break;
            default:
                logger.warn('Received unexpected event', payload);
        }
    }, [endLocalSession, handleOpenSession, handleUploadSelfieVerificationResult]);

    useEffect(() => {
        (window as any).SessionInterface = {
            onEvent
        };

        return () => {
            delete (window as any).SessionInterface;
        };
    }, [onEvent]);

    useEffect(() => {
        if (waitingStartSessionFromChildren) {
            if (isDevelopmentMode) {
                setTimeout(() => {
                    handleOpenSession(mockStartSessionParams);
                }, 1500);
            }
        }
    }, [waitingStartSessionFromChildren, isDevelopmentMode, handleOpenSession]);

    return null;
};

/**
 * @deprecated
 */
export const ClientConferenceSDKInterfaceOld: React.FC = () => {
    const {
        isDevelopmentMode, waitingStartSessionFromChildren,
        handleUploadSelfieVerificationResult, startSessionWithParams, endLocalSession
    } = useContext(ClientContext);

    const handleOpenSession = useCallback((clientSessionParamsString: string | ClientSessionParams) => {
        startSessionWithParams(parseJsonOrObject<ClientSessionParams>(clientSessionParamsString).value);
    }, [startSessionWithParams]);

    useEffect(() => {
        (window as any).handledBiometricValidationResult = handleUploadSelfieVerificationResult;
        (window as any).openVeriShowSession = handleOpenSession;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (window as any).Wrapper = {updateAdditionalInfo: () => { }};

        return () => {
            delete (window as any).handledBiometricValidationResult;
            delete (window as any).openVeriShowSession;
            delete (window as any).Wrapper;
        };
    }, [handleOpenSession, handleUploadSelfieVerificationResult, endLocalSession]);

    useEffect(() => {
        if (waitingStartSessionFromChildren) {
            if (isDevelopmentMode) {
                setTimeout(() => {
                    handleOpenSession(mockStartSessionParams);
                }, 1500);
            }
        }
    }, [waitingStartSessionFromChildren, isDevelopmentMode, handleOpenSession]);

    return null;
};
